import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DriverKpiStatisticComponent } from '../drivers/driver-kpi-statistic/driver-kpi-statistic.component';
import { DriverKpiTotalRevenueChartComponent } from '../drivers/driver-kpi-total-revenue-chart/driver-kpi-total-revenue-chart.component';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';
import { CompanyChargesComponent } from './company-charges/company-charges.component';
import { SettlementDetailComponent } from './settlement-detail/settlement-detail.component';
import { SettlementDetailsNewComponent } from './settlement-details-new/settlement-details-new.component';
import { SettlementListComponent } from './settlement-list/settlement-list.component';
import { SettlementOrderMapComponent } from './settlement-order-map/settlement-order-map.component';
import { SettlementPrintableComponent } from './settlement-printable/settlement-printable.component';
import { SettlementStatementRoutingModule } from './settlement-statement-routing.module';

@NgModule({
  declarations: [
    SettlementListComponent,
    SettlementDetailComponent,
    SettlementOrderMapComponent,
    SettlementPrintableComponent,
    SettlementDetailsNewComponent,
    CompanyChargesComponent,
    DriverKpiTotalRevenueChartComponent,
    DriverKpiStatisticComponent,
  ],
  imports: [
    CommonModule,
    SettlementStatementRoutingModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    DriverKpiTotalRevenueChartComponent,
    DriverKpiStatisticComponent,
  ],
})
export class SettlementStatementModule {}
